/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_MemecoinsInputs */

const en_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memecoins`)
};

const de_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meme-Coins`)
};

const pt_br2_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moedas meme`)
};

const tr_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memecoin'ler`)
};

const zh_cn2_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模因币`)
};

const zh_hk2_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迷因幣`)
};

const ko_kr2_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`밈코인`)
};

const ru_ru2_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мемкоины`)
};

const es_419_onboarding_v1_interest_memecoins = /** @type {(inputs: Onboarding_V1_Interest_MemecoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monedas meme`)
};

/**
* | output |
* | --- |
* | "Memecoins" |
*
* @param {Onboarding_V1_Interest_MemecoinsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_memecoins = /** @type {((inputs?: Onboarding_V1_Interest_MemecoinsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_MemecoinsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_memecoins(inputs)
	if (locale === "de") return de_onboarding_v1_interest_memecoins(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_memecoins(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_memecoins(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_memecoins(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_memecoins(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_memecoins(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_memecoins(inputs)
	return es_419_onboarding_v1_interest_memecoins(inputs)
});